import { MenuItem } from "@mui/material";
import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";
import { User } from "generated/graphql";
import useRestoreOrganizationUser from "hooks/users/useRestoreOrganizationUser";
import useConfirmationDialog from "hooks/useConfirmationDialog";
import { useCallback } from "react";

export default function RestoreAccountMenuItem({
  closeMenu,
  id,
}: {
  closeMenu: () => void;
  id: User["id"];
}) {
  const [restoreOrganizationUser, { isSuccess }] = useRestoreOrganizationUser();

  const acceptFn = useCallback(async (): Promise<boolean> => {
    const result = await restoreOrganizationUser({ variables: { id } });
    const success = isSuccess(result.data);
    if (success) {
      closeMenu();
    }
    return success;
  }, [id]);

  const cancelFn = useCallback(async () => {
    closeMenu();
    return true;
  }, []);

  const { open, setOpen, onAccept, onCancel } = useConfirmationDialog({
    acceptFn,
    cancelFn,
  });

  return (
    <>
      <ActionConfirmDialog
        open={open}
        setOpen={setOpen}
        handleAccept={onAccept}
        handleCancel={onCancel}
        title="Restore user?"
        content="This user will be restored, re-added to your subscription if applicable, and will appear in active user lists again."
        acceptText="Restore"
      />
      <MenuItem onClick={() => setOpen(true)}>Restore</MenuItem>
    </>
  );
}
